// 乗務員マスタの「デモ（Supabase未設定）時の置き場」。本番は Supabase の drivers テーブルが唯一の正で、
// この保管庫は一切使わない（isDemoStore() が false）。
//
// 何のために足したか（2026-09-03・給与スプリント01）:
//   給与は乗務員マスタの給与区分（歩合/月給/日給）・歩合率・固定給額が無いと何も出せない。
//   Supabase 未設定のデモ環境ではマスタが空のまま画面遷移で消えるため、給与の月給・日給や
//   「率を直したら額が変わる」動作をブラウザで確認できなかった。ブラウザローカル（localStorage）に
//   持たせて、デモでも本番と同じ操作手順を踏めるようにする。
//   本番の保存経路（drivers.js の upsert）には触れていない。
const KEY = 'veil-neb.demo.drivers'

const normCode = (c) => String(c == null ? '' : c).trim().replace(/^0+(?=\d)/, '')

// デモ保管庫を使う状況か（＝Supabase 未設定・またはデモ表示）。呼び出し側が online を渡す。
export function isDemoStore(online) { return !online }

// コード→乗務員doc の連想配列を返す（保存が無ければ空）。
export function loadDemoDrivers() {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return {}
    const obj = JSON.parse(raw)
    if (!obj || typeof obj !== 'object') return {}
    const out = {}
    for (const k in obj) { const id = normCode(k); if (id) out[id] = { ...obj[k], id, code: obj[k].code || id } }
    return out
  } catch { return {} }
}

// 1名分を保存（本番の upsert と同じく「既存へマージ」）。
export function saveDemoDriver(id, doc) {
  const code = normCode(id)
  if (!code) return
  try {
    const all = loadDemoDrivers()
    all[code] = { ...(all[code] || {}), ...(doc || {}), id: code, code }
    localStorage.setItem(KEY, JSON.stringify(all))
  } catch { /* private mode 等。デモの保存が効かないだけ */ }
}

// まとめて保存（実データ取込・CSV取込のデモ実行）。
export function saveDemoDrivers(map) {
  for (const k in (map || {})) saveDemoDriver(k, map[k])
}

// デモ保管庫を空にする（RUNBOOK の「状態のリセット」）。
export function clearDemoDrivers() {
  try { localStorage.removeItem(KEY) } catch { /* noop */ }
}
